import { ComponentMetadataModel, ParameterMetadata, ParameterType, PrimitiveType } from '../../../api/api';
import { ParameterTypes } from '../../../common/ParameterTypes';
import { VIRTUAL_COLLECTION_ITEM_MODEL_TYPE_PROPERTY } from '../Utils/VirtualComponentCollectionUtils';

function primitiveParameter(
	name: string,
	displayName: string,
	order: number,
	type: PrimitiveType,
	options?: { typeCustom?: string; isRequired?: boolean; defaultValue?: unknown; category?: string; valueOptions?: { name: string; value: string }[] },
): ParameterMetadata {
	return {
		name,
		displayName,
		order,
		type: ParameterType.Primitive,
		typeCustom: options?.typeCustom,
		category: options?.category,
		categories: options?.category ? [options.category] : [],
		isRequired: options?.isRequired,
		defaultValue: options?.defaultValue,
		isCollection: false,
		expectedType: { type },
		valueOptions: options?.valueOptions,
	};
}

function expressionParameter(name: string, displayName: string, order: number, type?: PrimitiveType, category = 'Events'): ParameterMetadata {
	return {
		name,
		displayName,
		order,
		type: ParameterType.Expression,
		category,
		categories: [category],
		isCollection: false,
		expectedType: type ? { type } : {},
	};
}

export const TableColumnActionMetadata: ComponentMetadataModel = {
	name: 'TableColumnAction',
	displayName: 'Action',
	category: 'Virtual',
	categories: ['Virtual'],
	description: 'A selectable action item used by component action collections.',
	parameters: [
		primitiveParameter(VIRTUAL_COLLECTION_ITEM_MODEL_TYPE_PROPERTY, 'Type', 1, PrimitiveType.String, {
			isRequired: true,
			defaultValue: 'Button',
			valueOptions: [
				{ name: 'Button', value: 'Button' },
				{ name: 'Link', value: 'Link' },
			],
		}),
		primitiveParameter('Label', 'Label', 2, PrimitiveType.String, { isRequired: true, defaultValue: 'Action' }),
		primitiveParameter('IconName', 'Icon Name', 3, PrimitiveType.String, { typeCustom: ParameterTypes.IconName }),
		primitiveParameter('IsDefault', 'Is Default', 4, PrimitiveType.Boolean, { defaultValue: false }),
		primitiveParameter('Path', 'Path', 10, PrimitiveType.String),
		primitiveParameter('View', 'View', 12, PrimitiveType.Object, { typeCustom: ParameterTypes.ViewId }),
		expressionParameter('ViewInput', 'View Input', 13),
		expressionParameter('OnSelected', 'On Selected', 20),
		expressionParameter('OnViewReturned', 'On View Returned', 21),
		expressionParameter('Disabled', 'Disabled', 30, PrimitiveType.Boolean, 'Advanced'),
		primitiveParameter('DisabledTooltip', 'Disabled Tooltip', 31, PrimitiveType.String, { category: 'Advanced' }),
		expressionParameter('Visible', 'Visible', 32, PrimitiveType.Boolean, 'Advanced'),
		expressionParameter('Hidden', 'Hidden', 33, PrimitiveType.Boolean, 'Advanced'),
	],
	iconName: 'TouchApp',
	isVirtual: true,
};
